module.exports = __webpack_public_path__ + "images/gift-card-icon-af65f0f06ef0c48daca3e7c40307d129.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/gift-card-icon.png
// module id = ./client/assets/images/gift-card-icon.png
// module chunks = 86